var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-table-simple",
    { attrs: { small: true, "sticky-header": "" } },
    [
      _c(
        "b-thead",
        [
          _c(
            "b-tr",
            [
              _c(
                "b-th",
                {
                  staticStyle: {
                    "text-align": "left",
                    "vertical-align": "middle",
                    width: "10%",
                  },
                },
                [_vm._v("Field")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: {
                    "text-align": "left",
                    "vertical-align": "middle",
                    width: "45%",
                  },
                },
                [_vm._v("Old")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: {
                    "text-align": "left",
                    "vertical-align": "middle",
                    width: "45%",
                  },
                },
                [_vm._v("New ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-tbody",
        _vm._l(_vm.items.new, function (ds, index) {
          return index != "update_date"
            ? _c(
                "b-tr",
                [
                  index !== "pages" && index != "datasources"
                    ? [
                        _c("b-td", [_vm._v(_vm._s(index))]),
                        _c("b-td", [_vm._v(_vm._s(_vm.items.old[index]))]),
                        _c("b-td", [_vm._v(_vm._s(_vm.items.new[index]))]),
                      ]
                    : _vm._e(),
                  index == "pages"
                    ? [
                        _c("b-td", [_vm._v(_vm._s(index))]),
                        _c(
                          "b-td",
                          { staticStyle: { "vertical-align": "top" } },
                          [
                            _c(
                              "b-table-simple",
                              { attrs: { small: true, "sticky-header": "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-th", [_vm._v("Name")]),
                                        _c("b-th", [_vm._v("Description")]),
                                        _c("b-th", [_vm._v("Preview")]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-tbody",
                                  _vm._l(
                                    _vm.items.old[index],
                                    function (page, idx1) {
                                      return _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(_vm._s(page.name)),
                                          ]),
                                          _c("b-td", [
                                            _vm._v(_vm._s(page.description)),
                                          ]),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                page.preview ? "Yes" : "No"
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "vertical-align": "top" } },
                          [
                            _c(
                              "b-table-simple",
                              { attrs: { small: true, "sticky-header": "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-th", [_vm._v("Name")]),
                                        _c("b-th", [_vm._v("Description")]),
                                        _c("b-th", [_vm._v("Preview")]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-tbody",
                                  _vm._l(
                                    _vm.items.new[index],
                                    function (page, idx1) {
                                      return _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(_vm._s(page.name)),
                                          ]),
                                          _c("b-td", [
                                            _vm._v(_vm._s(page.description)),
                                          ]),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                page.preview ? "Yes" : "No"
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  index == "datasources"
                    ? [
                        _c("b-td", [_vm._v(_vm._s(index))]),
                        _c(
                          "b-td",
                          { staticStyle: { "vertical-align": "top" } },
                          [
                            _c(
                              "b-table-simple",
                              { attrs: { small: true, "sticky-header": "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-th", [_vm._v("Name")]),
                                        _c("b-th", [_vm._v("Description")]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-tbody",
                                  _vm._l(
                                    _vm.items.old[index],
                                    function (page, idx1) {
                                      return _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(_vm._s(page.name)),
                                          ]),
                                          _c("b-td", [
                                            _vm._v(_vm._s(page.description)),
                                          ]),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "vertical-align": "top" } },
                          [
                            _c(
                              "b-table-simple",
                              { attrs: { small: true, "sticky-header": "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-th", [_vm._v("Name")]),
                                        _c("b-th", [_vm._v("Description")]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-tbody",
                                  _vm._l(
                                    _vm.items.new[index],
                                    function (page, idx1) {
                                      return _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(_vm._s(page.name)),
                                          ]),
                                          _c("b-td", [
                                            _vm._v(_vm._s(page.description)),
                                          ]),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e()
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }